import * as yup from 'yup';
import {
  dateField,
  exitTypeField,
  integerField,
  multiplierField,
  percentField,
  usdShortField,
} from './common-schema-defs';

export function companyFundMetricsFields() {
  return {
    acquisitionDate: yup.date(),
    acquisitionShares: yup.number(),
    initialInvestmentRound: yup.number(),
    amountInvested: usdShortField().label('Total Cost'),
    companyId: yup.number().required(),
    convertedSharesHeld: yup.number(),
    convertedOwnership: percentField().label('Ownership % (converted)'),
    customData: yup.object(),
    dilutionAssumption: yup.number(),
    distributions: usdShortField().label('Realized Value'),
    entryOwnership: percentField().label('Entry Ownership %'),
    exitDate: dateField(),
    exitOwnershipPercentage: percentField().label('Exit Ownership %'),
    exitType: exitTypeField(),
    exitValuation: usdShortField(),
    fmv: usdShortField().label('FMV'),
    fmvBasis: yup.number(),
    fundId: yup.number().required(),
    id: yup.number().required(),
    impliedEquityValue: usdShortField(),
    initialInvestmentDate: dateField().nullable(),
    initialPreMoney: usdShortField(),
    initialSharePrice: yup.number(),
    initialSharesHeld: yup.number(),
    irr: percentField().label('Gross IRR'),
    moic: multiplierField().label('MOIC'),
    noOfShares: integerField().label('Shares Held'),
    ownerShipPercentage: percentField().label('Ownership %'),
    ownershipSource: yup.number(),
    projectedExitTiming: yup.number(),
    projectedMOIC: yup.number(),
    projectedProceeds: yup.number(),
    reserves: usdShortField(),
    percentOfFund: percentField().label('Percentage of Fund'),
    percentTotalValue: percentField(),
    percentOfFmv: percentField().label('Company % of FMV'),
    rtfe: usdShortField().label('RTFE'),
    totalValue: usdShortField().label('Total Value'),
  };
}

export function companyFundMetricsFormSchema() {
  return yup.object().shape(companyFundMetricsFields());
}

export type CompanyFundMetricsDataModel = yup.InferType<ReturnType<typeof companyFundMetricsFormSchema>>;

export type CompanyFundMetricsField = keyof ReturnType<typeof companyFundMetricsFields>;
